import auth from '../../../services/auth'
import sales from '../../../services/sales'
import * as _ from 'lodash'
import { cents } from '../../../filters/number'
import axios from 'axios';
import validaRecarga from '../../../validators/recarga-minima'

export default {
  data() {
    return {
      user: auth.currentUser,
      rechargeValue: undefined,
      rate: 'N/A',
      loadingRates: Promise.resolve(true),
      loading: Promise.resolve(true),
      source: undefined,
      rechargeUnit: undefined,
      minValue: 200000,
      qtdFix: 4,
      rechargesData: {},
      unit: -1,
      msgError: undefined

    }
  },
  computed: {
    contractId: function () {
      return this.$route.params.contractId;
    },
    contract() {
      return this.$store.getters.getContractById(this.contractId);
    },
    planId: function(){
     return this.$route.params.planId;
    },
    valueFormatted: function () {
      this.$nextTick(()=>{
        $('#valueTotal').val($('#valueTotal').val());
      });
      return cents(this.rechargeValue).replace('R$', '');

    },
    total: function () {
      if (this.rate)
        return cents(this.rate.valueTotal + this.rate.taxTotal);
      else
        return cents(0);
    },
    tax: function () {
      if (this.rate)
        return cents(this.rate.taxTotal);
      else
        return cents(0);
    }
  },
  created() {
    this.source = axios.CancelToken.source();

  },
  watch:{
    unit(newValue) {
      this.msgError = undefined;
      if(newValue == -1)
        this.$nextTick(()=>{$('#valueTotal').focus();});
    },
    rechargeValue(newValue) {
      const rechargeValueNumber = Number(newValue);
      if (rechargeValueNumber % 50 !== 0) {
        this.msgError = "O valor deve ser múltiplo de 50.";
      } else {
        this.msgError = undefined;
      }
    }
  },
  mounted() {
    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue, true);
    this.unit = this.rechargesData[0].value;
  },
  methods: {
    incrementTotal: function (val) {
      val = parseInt(val);
      let total = parseInt(this.rechargeValue);
      if (this.rechargeValue)
        this.rechargeValue = total + val;
      else
        this.rechargeValue = val;

      this.calculateRecharge();
      this.$nextTick(function () {
          this.$validator.validateAll();
      })
    },
    setTotal: function (newValue) {
      this.msgError = undefined;
      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
      this.calculateRecharge();
    },
    getQuantity: function () {
      if (!this.rechargeValue)
        return 0;

      let val = this.rechargeValue;
      val = parseInt(val);
      return val / this.unit;
    },
    calculateRecharge: function () {
      if (!validaRecarga.validate(this.rechargeValue, [this.minValue])) {
        this.rate = 'N/A';
        return false;
      }
      this.source.cancel('cancelada');
      this.source = axios.CancelToken.source();
      this.waiting = true;
      let promise = sales.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: this.contractId})
        .then(resp => {
          this.rate = resp.taxTotal
          this.waiting = false;
        }).catch(err => {
          this.waiting = false;
          this.rate = 'N/A';
        });
      this.$store.dispatch('loading', promise);
    },
    getSalesOrder() {
      if(this.msgError){
        return false;
      }
      this.msgError = undefined;
        if(this.unit == -1 && (!this.rechargeValue || parseInt(this.rechargeValue) < parseInt(this.minValue))){
          this.msgError = `Valor de recarga inválido`;
          return false;
        }

          let v = 0;
          let r = 0;
          if(this.unit == -1){
            v = this.rechargeValue;
            r = this.rate;
          }
          else {
            v = this.unit;
            r = _.find(this.rechargesData, (o) => {
              return o.value == this.unit
            }).tax;
          }


            let salesOrder = {
              account: {moveMaisId: this.moveMaisId},
              type: "RECHARGE",
              salesType: "RECHARGE",
              _interface: window.document.webview ? "MOBILE" : "WEBSITE",
              contract: this.contractId,
              price: parseInt(v) + parseInt(this.rate),
              value: parseInt(v),
              products: [
                {
                  productId: 2,
                  productName: "RECARGA",
                  quantity: 1,
                  valueTotal: v,
                  valueUnit: v
                },
                {
                  productId: 3,
                  productName: "TAXA DE RECARGA",
                  quantity: 1,
                  valueTotal: r,
                  valueUnit: r
                }
              ]
            };


            return Promise.resolve(salesOrder);


    }


  },

  components: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/recharge/recharge-open.js